module.exports = __webpack_public_path__ + "static/media/big_unicorn.3de55567.png";